export default {
  'menu.ad-callback.x-callback': 'X API',
  'menu.ad-callback.trafficstars-callback': 'TrafficStars S2S',
  'menu.system.access-logs': '系统验证记录',
  'menu.welcome': '欢迎',
  'menu.staff-accounts': '员工',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.changePassword': '修改密码',
  'menu.purchaseHistory': '购买记录',
  'menu.domainRental': '域名租用',
  'menu.register-result': '注册结果',
  'menu.system': '系统管理',
  'menu.system.order-management': '订单管理',
  'menu.system.user-management': '用户管理',
  'menu.system.site-config': '网站配置',
  'menu.system.params-config': '参数配置',
  'menu.system.domain-config': '域名配置',
  'menu.system.baota-config': '宝塔配置',
  'menu.system.nginx-ip-block': 'WhatsApp IP拦截',
  'menu.system.email-template': '邮件模板',
  'menu.system.rental-domain-management': '租用管理',
  'menu.system.cloak-blacklist-management': '斗篷IP管理',
  'menu.cloak-whitelist-management': '斗篷白名单',
  'menu.system.cloak-whitelist-management': '斗篷白名单',
  'menu.system.membership-plans': '会员套餐配置',
  'menu.system.template-library-management': '模板库管理',
  'menu.system.wallet-config': '钱包配置',
  'menu.system.recharge-records': '充值记录',
  'menu.system.agent-management': '代理管理',
  'menu.system.landing-page-management': '落地页管理',
  'menu.system.public-review-page-management': '公共审核页',
  'menu.system.doc-category-management': '文档分类',
  'menu.system.doc-management': '文档管理',
  'menu.system.doc-create': '新建文档',
  'menu.system.doc-edit': '编辑文档',
  'menu.overseas': '海外分流',
  'menu.overseas.kakao-list': 'KaKaoTalk',
  'menu.overseas.whatsapp-list': 'WhatsApp',
  'menu.overseas.whatsapp-stats': 'WhatsApp统计',
  'menu.overseas.line-list': 'Line',
  'menu.overseas.facebook-diversion': 'Facebook',
  'menu.overseas.tg-list': 'Telegram',
  'menu.overseas.custom-diversion': '自定义分流',
  'menu.overseas.sms-list': '短信SMS',
  'menu.overseas.service-management': '服务管理',
  'menu.overseas.media-buyer': '投手服务',
  'menu.overseas.work-order': '工单管理',
  'menu.customer-diversion': '极速分流',
  'menu.customer-diversion.whatsapp': 'WhatsApp',
  'menu.customer-diversion.line': 'Line',
  'menu.customer-diversion.facebook': 'Facebook',
  'menu.customer-diversion.custom': '自定义分流',
  'menu.customer-diversion.tg': 'Telegram',
  'menu.customer-diversion.service-management': '服务管理',
  'menu.customer-diversion.media-buyer': '投手服务',
  'menu.ad-callback': '广告回传',
  'menu.ad-callback.tiktok-callback': 'Tiktok API',
  'menu.ad-callback.tiktok-create': '新建配置',
  'menu.ad-callback.tiktok-edit': '编辑配置',
  'menu.ad-callback.tiktok-stats': '统计分析',
  'menu.ad-callback.facebook-callback': 'Facebook API',
  'menu.ad-callback.facebook-create': '新建配置',
  'menu.ad-callback.facebook-edit': '编辑配置',
  'menu.ad-callback.facebook-stats': '统计分析',
  'menu.ad-callback.manual-ad-callback': '手动回传',
  'menu.ad-callback.manual-ad-callback-create': '新建手动回传',
  'menu.ad-callback.pinterest-callback': 'Pinterest API',
  'menu.ad-callback.pinterest-create': '新建配置',
  'menu.ad-callback.pinterest-edit': '编辑配置',
  'menu.ad-callback.pinterest-stats': '统计分析',
  'menu.ad-callback.bigo-callback': 'BigO API',
  'menu.ad-callback.bigo-create': '新建配置',
  'menu.ad-callback.bigo-edit': '编辑配置',
  'menu.ad-callback.bigo-stats': '统计分析',
  'menu.ad-callback.google-callback': 'Google',
  'menu.ad-callback.google-create': '新建配置',
  'menu.ad-callback.google-edit': '编辑配置',
  'menu.ad-callback.google-stats': '统计分析',
  'menu.ad-callback.superh-callback': '超级回传',
  'menu.ad-callback.superh-create': '新建超级回传',
  'menu.ad-callback.superh-edit': '编辑超级回传',
  'menu.ad-callback.deep-callback': '深度回传',
  'menu.ad-callback.external-callback': '外部回传',
  'menu.ad-callback.external-create': '新建外部回传',
  'menu.ad-callback.external-edit': '编辑外部回传',
  'menu.ad-callback.external-stats': '统计分析',
  'menu.landing-page': '落地页',
  'menu.landing-page.page-list': '落地页列表',
  'menu.landing-page.ai-landing-page': 'AI落地页',
  'menu.landing-page.ai-landing-page-list': 'AI落地页列表',
  'menu.landing-page.ai-landing-page-create': '创建AI落地页',
  'menu.landing-page.ai-landing-page-edit': '编辑AI落地页',
  'menu.landing-page.form-management': '表单管理',
  'menu.landing-page.ad-callback-selection': '广告回传',
  'menu.landing-page.ad-callback-selection-ios': '本地广告回传',
  'menu.landing-page.page-stats': '访问统计',
  'menu.landing-page.template-library': '模板库',
  'menu.landing-page.page-create': '创建落地页',
  'menu.landing-page.page-edit': '编辑落地页',
  'menu.cloak': '斗篷管理',
  'menu.chat-management': 'Chat管理',
  'menu.membership': '会员中心',
  'menu.membership.membership-buy': '会员购买',
  'menu.pricing': '套餐',
  'menu.docs': '使用文档',
  'menu.doc-detail': '文档详情',
  'menu.bbs': '论坛',
  'menu.user-domain': '我的域名',
  'menu.myShares': '分享管理',
  'menu.myAgent': '我的推广',
  'menu.shareView': '查看分享',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
};
